"use client";

import { useEffect } from "react";
import { StatusPage } from "@/components/pages/StatusPage";
import { getStatusCopy } from "@/lib/status-copy";

const copy = getStatusCopy("en", "error");

export default function EnError({
  error,
  reset,
  retry,
}: {
  error: Error & { digest?: string };
  reset: () => void;
  retry?: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return <StatusPage copy={copy} onReset={retry ?? reset} />;
}
